import PressableWord from "./PressableWord"

export default PressableWord
